<template>
  <div class="mdl-dialog modal-container center">
    <div class="mdl-dialog__content">
      <i class="material-icons big-icon">delete_forever</i>

      <h1 class="headline">Revoke all submissions?</h1>
      <p>
        You will revoke all previous submissions for:
      </p>

      <p>
        <b>{{ unit }}</b>
        of
        <b>{{ address }}</b>
      </p>

      <p>This action cannot be undone.</p>

      <p class="accent--color">
        <b>CLOSE THIS IF YOU DO NOT WANT TO CONTINUE.</b>
      </p>

      <p>Otherwise, click REVOKE NOW to confirm.</p>
    </div>
    <div class="mdl-dialog__actions">
      <button
        type="button"
        @click="$emit('close-modal')"
        class="mdl-button mdl-js-button mdl-button--raised"
      >
        <i class="material-icons hide-small">close</i>
        Close
      </button>

      <button
        type="button"
        @click="$emit('revoke')"
        class="mdl-button mdl-js-button"
      >
        <i class="material-icons fade hide-small">delete_forever</i>
        Revoke Now
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    unit: {
      type: String,
      required: true
    },
    address: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
@media only screen and (max-width: 450px) {
  .hide-small {
    display: none;
  }
}

.fade {
  opacity: 0.67;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/RevokeModal/RevokeModalDefault.vue